import { Card } from "@/components/ui/card";
import { Heart, Gift, Briefcase } from "lucide-react";

const useCases = [
  {
    id: 1,
    icon: Heart,
    title: "Personal Moments",
    description: "Turn your favorite moments into custom stickers, mugs, and more.",
    examples: ["Wedding photos", "Pet portraits", "Family memories"],
    color: "text-pink-500",
    bgColor: "bg-pink-500/10",
  },
  {
    id: 2,
    icon: Gift,
    title: "Unique Gifts",
    description: "Create one-of-a-kind gifts for any occasion.",
    examples: ["Birthday designs", "Holiday presents", "Thank-you gifts"],
    color: "text-amber-500",
    bgColor: "bg-amber-500/10",
  },
  {
    id: 3,
    icon: Briefcase,
    title: "Business & Brand",
    description: "Custom merch and branded products for your business.",
    examples: ["Company swag", "Event giveaways", "Marketing materials"],
    color: "text-blue-500",
    bgColor: "bg-blue-500/10",
  },
];

export function UseCaseSection() {
  return (
    <section className="py-16 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-12 sm:mb-16 space-y-4 px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">What Will You Create?</h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto">
            From personal keepsakes to business merchandise—bring any idea to life
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {useCases.map(useCase => (
            <Card key={useCase.id} className="p-6 hover:shadow-lg transition-shadow">
              <div
                className={`inline-flex items-center justify-center w-10 h-10 rounded-lg ${useCase.bgColor} mb-4`}
              >
                <useCase.icon className={`w-5 h-5 ${useCase.color}`} />
              </div>
              <h3 className="text-lg font-semibold mb-2">{useCase.title}</h3>
              <p className="text-muted-foreground mb-4">{useCase.description}</p>
              <ul className="space-y-1">
                {useCase.examples.map(example => (
                  <li
                    key={example}
                    className="text-sm text-muted-foreground flex items-center gap-2"
                  >
                    <span className="w-1 h-1 rounded-full bg-primary/60 shrink-0" />
                    {example}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
